export enum BoxShadowValues {
  TYPE = 'type',
  COLOR = 'color',
  X = 'x',
  Y = 'y',
  BLUR = 'blur',
  SPREAD = 'spread',
  BLEND_MODE = 'blendMode',
}
